import React, { PureComponent } from "react";
import createHistory from "history/createBrowserHistory";
import { Router, Route, Switch } from "react-router-dom";
// import ReactGA from "react-ga";

// Views
import {
  BlogArticleDetails,
  Biond,
  Blog,
  Business,
  Contact,
  Error404,
  FAQ,
  Index,
  Pricing,
  PrivacyPolicy,
  StyleGuide,
  TOS
} from "views";

import {
  indexRoute,
  articleRoute,
  biondRoute,
  blogRoute,
  businessRoute,
  contactRoute,
  faqRoute,
  pricingRoute,
  privacyPolicyRoute,
  termsOfServiceRoute,
  styleguideRoute
} from "constants/routes";

import { Footer } from "components";
import Header from "components/Header/Header";

// Analytics
// ReactGA.initialize('UA-xxxxxxxxx')

// History
const history = createHistory();
history.listen((location, action) => {
  window.scrollTo(0, 0);
  document.body.classList.remove("is-locked");
});

class Layout extends PureComponent {
  render() {
    return (
      <Router history={history}>
        <div className="container">
          <Header />
          <Switch>
            {/* Main routes */}
            <Route exact path={indexRoute} component={Index} />
            <Route path={biondRoute} component={Biond} />
            <Route path={blogRoute} exact component={Blog} />
            <Route path={businessRoute} component={Business} />
            <Route path={contactRoute} component={Contact} />
            <Route path={faqRoute} component={FAQ} />
            <Route path={pricingRoute} component={Pricing} />
            <Route path={privacyPolicyRoute} component={PrivacyPolicy} />
            <Route path={termsOfServiceRoute} component={TOS} />
            <Route path={articleRoute} component={BlogArticleDetails} />

            {/* Development only route for styleguide */}
            {process.env.NODE_ENV === "development" && (
              <Route exact path={styleguideRoute} component={StyleGuide} />
            )}

            {/* Fallback error route if others are not matched */}
            <Route component={Error404} />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/Layout.jsx